import HappyRestaurantIcon from '@stencil/icons/src/HappyRestaurantIcon/HappyRestaurantIcon';
import * as S from './NoDiningComponent.styles';

interface NoDiningComponentProps {
  roomServiceText: string;
}
export default function NoDiningComponent({
  roomServiceText = 'No dining, food will be served in the room.',
}: NoDiningComponentProps) {
  return (
    <>
      <S.NoDiningWrapper>
        <HappyRestaurantIcon height="2.4rem" width="2.4rem" fill="#ff3a5c" />
        <S.NoDiningText>{roomServiceText}</S.NoDiningText>
      </S.NoDiningWrapper>
    </>
  );
}
